export enum LabelType {
  MAILBOX = "mailbox",
  DNS = "dns",
  POSTMASTER = "postmaster",
  TEMPLATE = "template",
  SENDER_PROFILE = "sender_profile",
}

export interface ILabel {
  _id: string;
  name: string;
  description: string;
  color: string;
  companyId: string;
  labelType: LabelType;
  createdBy: string;
  updatedAt: string;
  createdAt: string;
}

export interface ILabelResponse {
  labels: ILabel[];
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export type AssignedLabel = Pick<ILabel, "_id" | "name" | "color">;